export const githubFields = [
  { name: "Name", property: "name" },
  { name: "Installation Id", property: "id" },
];
